import LoadButton from "./LoadButton";

export default LoadButton;